export const PREFERS_REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion)").matches === false;
